<template>
  <div class="backstage-index">
    <page-head  @loginOut="loginOut" />
    <PageTags></PageTags>
    <div class="backstage-container" id="pageContent">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import PageHead from "@/components/layout/page-head.vue";
import PageTags from "@/components/layout/tags.vue";
import User from "models/user";
const user = new User();
import { deleteToken, delDBUserRealName, delTags } from "@/common/js/storage";
export default {
  components: {
    PageHead,
    PageTags
  },

  data() {
    return {
    };
  },
  created() {
  },

  methods: {
    loginOut() {
      user.postUserLogout().then(res => {
        if (res.success) {
          deleteToken();
          delTags();
          delDBUserRealName();
          this.$router.push("/login");
        }
      });
    }
  },
};
</script>

<style lang='scss'>
@import '@/assets/style/common.scss';
</style>
